import { render, staticRenderFns } from "./hotSale.vue?vue&type=template&id=51ecf7ee&scoped=true"
import script from "./hotSale.vue?vue&type=script&lang=js"
export * from "./hotSale.vue?vue&type=script&lang=js"
import style0 from "./hotSale.vue?vue&type=style&index=0&id=51ecf7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecf7ee",
  null
  
)

export default component.exports